function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
var baseClass = 'ap-radio';
var InnerRadioInput = function InnerRadioInput(props) {
  var input = props.input,
    customClass = props.customClass,
    meta = props.meta,
    inline = props.inline,
    label = props.label,
    info = props.info,
    id = props.id,
    passedProps = _objectWithoutProperties(props, ['input', 'customClass', 'meta', 'inline', 'label', 'info', 'id']);
  var bemClasses = getBEMClasses([baseClass, customClass]);
  delete passedProps.meta;
  return React.createElement('div', {
    className: bemClasses(null, {
      inline: inline
    })
  }, React.createElement('input', Object.assign({
    className: bemClasses('input'),
    type: 'radio'
  }, input, passedProps, {
    id: id
  })), React.createElement('label', {
    className: bemClasses('label'),
    htmlFor: id
  }, label, React.createElement('span', {
    className: bemClasses('check')
  }), React.createElement('span', {
    className: bemClasses('checked')
  })), info && React.createElement('small', {
    className: 'form-text-muted ' + bemClasses('radio-info')
  }, info), meta.dirty && meta.error && React.createElement('span', {
    className: bemClasses('radio-error')
  }, meta.error));
};
export { InnerRadioInput };
var APRadio = function APRadio(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: InnerRadioInput,
    type: 'radio'
  }, props));
};
APRadio.defaultProps = {
  name: '',
  label: '',
  autoFocus: false,
  required: false,
  readOnly: false,
  inline: false,
  info: ''
};
APRadio.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  customClass: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  inline: PropTypes.bool,
  info: PropTypes.string,
  id: PropTypes.string.isRequired
};
export default APRadio;